const signinConstraints = (customValidationMessages) => ({
  loginEmail: {
    ...customValidationMessages.loginEmail,
    presence: {
      allowEmpty: false,
    },
    email: true,
  },
  loginPassword: {
    ...customValidationMessages.loginPassword,
    presence: {
      allowEmpty: false,
    },
  },
})

export default signinConstraints
